
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c21447","d":"M0 10h.252a8 8 0 1115.496 0H16L9 25H7z"}}),_c('path',{attrs:{"fill":"#fff","d":"M3.932 7.5a.371.371 0 00-.274.626l4.068 4.258a.383.383 0 00.547 0l4.069-4.258a.371.371 0 000-.51.378.378 0 00-.546 0L8 11.589 4.205 7.616a.386.386 0 00-.273-.116z"}})])
          )
        }
      }
    